export default {
  "p_comments:delete": "Комментарии: Удаление",
  "p_comments:edit": "Комментарии: Редактирование",
  "p_comments:create": "Комментарии: Создание",
  "p_comments:view": "Комментарии: Просмотр",
  "p_price+proposals+++delete": "Предложения по цене: Удаление",
  "p_price+proposals+++edit": "Предложения по цене: Редактирование",
  "p_price+proposals+++create": "Предложения по цене: Создание",
  "p_price+proposals+++view": "Предложения по цене: Просмотр",
  "p_change+protected+statuses": "Изменение защищенных статусов",
  "p__request+rate": "Запросы на цену",
  "p_delete+requests": "Удаление запросов",
  "p_editing+requests": "Редактирование запросов",
  "p_create+requests": "Чтение запросов",
  "p_view+requests": "Просмотр запросов",
  "p_edit+contact": "Контакты: Редактирование",
  "p_change+credit+limit": "Кредитный лимит: Изменение",
  "p_delete+clients": "Клиенты: Удаление",
  "p_editing+clients": "Клиенты: Редактирование",
  "p_create+clients": "Клиенты: Создание",
  "p_view+clients": "Клиенты: Просмотр",
  "p_delete+carriers": "Перевозчики: Удаление",
  "p_editing+carriers": "Перевозчики: Редактирование",
  "p_create+carriers": "Перевозчики: Создание",
  "p_view+carriers": "Перевозчики: Просмотр",
  "p_documents(transportation,+cmr,+photo):+view":
    "Документы (транспортировка, CMR, фото): Просмотр",

  "p_other:+view": "Прочее: Просмотр",
  "p_act:+view": "Акт: Просмотр",

  "p_other:+create": "Прочее: Создание",
  "p_other:+delete": "Прочее: Удаление",
  "p_other:+edit": "Прочее: Редактирование",

  "p_acts:+create": "Акты: Создание",
  "p_acts:+delete": "Акты: Удаление",
  "p_acts:+edit": "Акты: Редактирование",

  "p_edit+paid+invoices": "Оплаченные счета: Редактирование",

  p_delete: "Удаление",
  p_edit: "Редактирование",
  p_create: "Создание",
  p_view: "Просмотр",

  "p_edit+paid+invoices_2": "Оплаченные счета: Редактирование",
  p_delete_2: "Удаление",
  p_edit_2: "Редактирование",
  p_create_2: "Создание",
  p_view_2: "Просмотр",

  "p_edit+order+status+history": "История статусов заказа: Редактирование",
  "p_view+order+status+history": "История статусов заказа: Просмотр",

  "p_delete+financial": "Финансы: Удаление",
  "p_edit+financial": "Финансы: Редактирование",
  "p_view+financial": "Финансы: Просмотр",

  "p_edit+freight": "Фрахт: Редактирование",
  "p_view+freight": "Фрахт: Просмотр",

  p_margin: "Маржа",
  p_total: "Итого",

  "p_trips+in+order": "Рейсы в заказе",

  "p_documents(transportation,+cmr,+phtoto)":
    "Документы (транспортировка, CMR, фото)",

  "p_cargo+information": "Информация о грузе",
  "p_client+information": "Информация о клиенте",

  p_profit: "Прибыль",

  "p_delete+orders": "Заказы: Удаление",
  "p_edit+status": "Статус: Редактирование",
  "p_editing+orders": "Заказы: Редактирование",
  "p_create+orders": "Заказы: Создание",
  "p_view+orders": "Заказы: Просмотр",

  "p_delete+trips": "Рейсы: Удаление",
  "p_update+trips": "Рейсы: Обновление",
  "p_create+trips": "Рейсы: Создание",
  "p_trips+view": "Рейсы: Просмотр",

  "p_your+own+departments+orders": "Заказы своего отдела",
  "p_your+own+orders": "Свои Заказы",
  "p_all+orders": "Все Заказы",

  "p_your+own+departments+requests": "Запросы своего отдела",
  "p_your+own+requests": "Свои Запросы",
  "p_all+requests": "Все Запросы",

  "p_your+own+departments+clients": "Клиенты своего отдела",
  "p_your+own+clients": "Свои Клиенты",
  "p_all+clients": "Все Клиенты",

  "p_your+own+departments+carriers": "Перевозчики своего отдела",
  "p_your+own+carriers": "Свои Перевозчики",
  "p_all+carriers": "Все Перевозчики",

  "p_your+own+departments+trips": "Рейсы своего отдела",
  "p_your+own+trips": "Свои Рейсы",
  "p_all+trips": "Все Рейсы",

  l_Username: "Имя пользователя",
  l_User_password: "Пароль",
  l_Forgot_password: "Восстановить пароль",
  l_Login: "Войти",
  l_Sign_out: "Выход",
  l_EmailorPasswordisWrong: "Электронная почта или пароль неверны",
  l_Requests: "Запросы",
  l_Orders: "Заказы",
  l_Finance: "Финансы",
  l_Clients: "Клиенты",
  l_Carriers: "Перевозчики",
  l_Settings: "Параметры",
  l_Organization: "Организация",
  l_Templates: "Шаблоны",
  l_Classifiers: "Справочники",
  l_System: "Система",
  l_Log: "Логи",
  l_Add_places: "Перенести маршрут из груза",
  l_Change_password: "Поменять пароль",
  l_New_rail_station: "Новая ЖД станция",
  l_Station: "ЖД станция",
  l_Rail_stations: "ЖД станции",
  l_Companies: "Компании",
  l_Client_to_user: "Доступ для клиентов",
  l_Departments: "Отделы",
  l_Give_access_to_client: "Предоставить доступ клиенту",
  l_Employees: "Сотрудники",
  l_Groups_of_employees: "Группы сотрудников",
  l_Business_number: "Номер типа",
  l_Company_name: "Название компании",
  l_Name_in_original: "Название на языке оригинала",
  l_Company_code: "Код компании",
  l_VAT_code: "Код НДС",
  l_Cargo_information: "Информация о грузе",
  l_Address: "Адрес",
  l_Failed_to_submit: "Ошибка при загрузке",
  l_Address_for_correspondence: "Адрес для корреспонденции",
  l_Banks: "Банки",
  l_Calculations: "Расчеты",
  l_Cargo_statuses: "Статусы грузов",
  l_Client_types: "Типы клиентов",
  l_Provide_access_to_carrier: "Предоставить доступ перевозчику",
  l_Document_statuses: "Статусы документов",
  l_Order_statuses: "Статусы заказов",
  l_Railway_stations: "Железнодорожные станции",
  l_Transport_types: "Типы транспорта",
  l_Trip_statuses: "Статусы рейсов",
  l_VAT_rates: "Тарифы НДС",
  l_Workers_posts: "Должности сотрудников",
  l_Whatsapp_notification_send: "Отправка уведомления по WhatsApp",
  l_Name: "Название",
  l_Unofficial_name: "Название неофициальное",
  l_Branch: "Филиал",
  l_Code__: "МФО (БИК, BLZ)",
  l_Post_code: "Почтовый код",
  l_LanguageSettings: "Настройки языка",
  l_SystemLogs: "Системные логи",
  l_Notifications: "Уведомления",
  l_Preferences: "Предпочтения",
  l_ExportData: "Экспорт данных",
  l_DataPrivacy: "Конфиденциальность данных",
  l_TermsAndConditions: "Условия и положения",
  l_Help: "Помощь",
  l_FAQ: "Часто задаваемые вопросы",
  l_ChangePassword: "Изменить пароль",
  l_Other_docs: "Другие документы",
  l_Transportation_orders: "Заявки",
  l_Overhead_docs: "Накладные",
  l_Request_doc: "Документы из запроса",
  l_Backup: "Резервное копирование",
  l_AdvancedSettings: "Расширенные настройки",
  l_Support: "Поддержка",
  l_PrivacyPolicy: "Политика конфиденциальности",
  l_Subscription: "Подписка",
  l_LanguagePreference: "Предпочтение языка",
  l_TimeZone: "Часовой пояс",
  l_Export_to_excel: "Excel",
  l_UserProfile: "Профиль пользователя",
  l_Change_group_cargo_status: "Изменить статус грузов (группа)",
  l_EmailPreferences: "Настройки электронной почты",
  l_Feedback: "Обратная связь",
  l_Action: "Действие",
  l_Add: "Добавить",
  l_Shipment: "Отгрузки",
  l_Transportation: "Заявки",
  l_Price_and_payment_term: "цена и условия оплаты",
  l_Issued_invoice: "Выписанные счета",
  l_Overhead: "Накладные",
  l_Freezing_order: "Заморозка заказа",
  l_Additional_expenses: "Доп. расходы",
  l_Trip_costs: "Расходы рейсов",
  l_Unrecorded_expenses: "Неучтенные расходы",
  l_Update: "Обновить",
  l_Edit: "Редактировать",
  l_Submit: "Отправить",
  l_Cancel: "Отменить",
  l_Are_you_sure_delete_this_task: "Вы уверены, что хотите удалить эту задачу?",
  l_Yes: "Да",
  l_No: "Нет",
  l_Keyword: "Ключевое слово",
  l_Search: "Поиск",
  l_Active: "Активный",
  l_Initial: "Начальный",
  l_Final: "Последний",
  l_NotFound: "Не найден",
  l_Succeed: "Операция прошла успешно",
  l_Segment_name: "Название сегмента",
  l_Segment_priority: "Приоритет сегмента",
  l_Color: "Цвет",
  l_By_default: "По умолчанию",
  l_Yellow: "Желтый",
  l_Green: "Зеленый",
  l_Grey: "Серый",
  l_Red: "Красный",
  l_Orange: "Оранжевый",
  l_Status_name: "Название статуса",
  l_Priority: "Очередность",
  l_Status_type: "Тип статуса",
  l_Text_colour: "Цвет шрифта",
  l_Background_colour: "Цвет фона",
  l_After_setting_status: "После установки статуса",
  l_Message_for_seller: "Сообщение для продавца",
  l_Topic_of_the_message_for_seller_TWIG: "Тема сообщения для продавца TWIG",
  l_Name_2: "Наименование",
  l_Railway_station: "ЖД станция",
  l_Code: "Код",
  l_Railway: "Железная дорога",
  l_Railway2: "Железнодорожный транспорт",
  l_Rate: "Тариф",
  l_Legal_name: "Официальное имя",
  l_VAT_law: "Закон НДС",
  l_third_party_code: "Сторонний код",
  l___CountVat: "Тариф не используется в подсчете НДС",
  l_Default_VAT_rate: "Тариф НДС по умолчанию",
  l_Error: "Ошибка",
  l_Basic_information: "Основная информация",
  l_Custom_data: "Таможня разгрузки",
  l_Reloading_place: "Место перегрузки",
  l_ContactInfo: "Контактная информация",
  l_Signatures: "Изображения для документов",
  l_Directors_full_name: "ФИО руководителя",
  l_In_the_name_of_whom: "В лице кого",
  l_Expense_templates: "Шаблоны расходов",
  l_Custom_loading_data: "Таможня загрузки",
  l_Reloading_date: "Дата перегрузки",
  l_Post: "Должность",
  l_VAT_rate: "Тариф НДС",
  l_RRC: "КПП",
  l_OGRN: "ОГРН",
  l_Loading_place_custom: "Таможня загрузки",
  l_Size: "Размер",
  l_Is_general: "Основной статус",
  l_You_dont_have_permission: "У вас нету доступа на это действие",
  l_Is_automating_sending: "Автоматом отправляется",
  l_Pricing_type: "Тип расчета цены",
  l_Contact_information: "Контактная информация",
  l_Form_contains_errors: "Форма содержит ошибки",
  l_Country: "Страна",
  l_Price_show: "Ценник",
  l_City: "Город",
  l_There_is_nothing: "Никаких уведомлений",
  l_Correspondent_information: "Correspondent information",
  l_Telephone: "Телефон",
  l_Fax: "Факс",
  l_Email: "Эл.почта",
  l_Website: "Сайт",
  l_Main_company: "Основная компания",
  l_Operating_account: "Расчетный счет",
  l_Bank_code: "Код банка",
  l_Bank: "Банк",
  l_Different_invoices_for_different_currencies:
    "Разные счета для разных валют",
  l_Currency: "Валюта",
  l_Correspondent_bank: "Банк корреспондент",
  l_Print: "Печать",
  l_Company_logotype: "Логотип компании",
  l_Signature: "Подпись",
  l_correspondent_account: "К/с",
  l_Inc_VAT_price: "Цена с НДС",
  l_Ex_VAT_price: "Цена без НДС",
  l_Bank_name: "Название банка",
  l_Click_or_drag_ile_to_this_area_to_upload:
    "Нажмите или перетащите файл в эту область, чтобы загрузить",
  l_Department_name: "Название отдела",
  l_Department_prefix: "Префикс отдела",
  l_Company: "Компания",
  l_Login_email: "Логин Эл.почта",
  l_Groups: "Группы",
  l_Name_Surname: "Имя, фамилия",
  l_Surname: "Фамилия",
  l_Date_of_last_visit: "Дата последнего посещения",
  l_Mail_settings: "Настройки почты",
  l_Password: "Пароль",
  l_Reset_your_password: "Вы уверены, что хотите сбросить пароль?",
  l_For_bonus: "% для бонуса, %",
  l_Employee_prefix: "Префикс сотрудника",
  l_Department: "Отдел",
  l_Access_rights: "Права доступа",
  l_All: "Все",
  l_YourOwnDepartment: "Ваш отдел",
  l_YourOwn: "Только свой",
  l_Unlimited_access: "Неограниченный доступ",
  l_Additional_information: "Дополнительная информация",
  l_Main: "Основное",
  l_Access: "Доступ",
  l_Special_rights: "Спец. права",
  l_Group: "Группа",
  l_Numeration: "Нумерации",
  l_Numeration_name: "Название нумерации",
  l_Numeration_for: "Нумерация",
  l_Employee: "Сотрудник",
  l_Prefix: "Префикс",
  l_Year: "Год",
  l_Month: "Месяц",
  l_Delimiter: "Разделитель",
  l_Number_of_digits: "Кол-во цифр",
  l_Index: "Индекс",
  l_Suffix: "Суффикс",
  l_View: "Просмотр",
  l_Client: "Клиент",
  l_Consolidation: "Консолидация",
  l_Status_characteristic: "Характеристика статуса",
  l_Cargos: "Грузы",
  l_Trips: "Рейсы",
  l_Cargos_status: "Статус грузов",
  l_Salary_calculation: "Расч. зарплаты",
  l_Show_filters: "Показать фильтры",
  l_New_status: "Новый статус",
  l_Car_trip: "Авто рейс",
  l_Order_date: "Дата заказа",
  l_Date: "Дата",
  l_Users: "Пользователи",
  l_Documents: "Документы",
  l_Transport: "Транспорт",
  l_Other: "Другое",
  l_Sort: "Сортировка",
  l_Order_number: "Нр. заказа",
  l_Cargos_and_routes: "Грузы и маршруты",
  l_Order_status: "Статус заказа",
  l_New_trip: "Новый рейс",
  l_Loading_area: "Место загрузки",
  l_Unloading_area: "Место разгрузки",
  l_Loading_date: "Дата загрузки",
  l_Days_of_trip: "Дней в пути",
  l_Wagon_number: "Номер вагона",
  l_Car_number: "Номер машины",
  l_Invoice_number: "Номер счета",
  l_Invoice_issued: "Счет выписан",
  l_Pay_until: "Оплатить до",
  l_History_payment: "История платежей",
  l_Received: "Дата платежа",
  l_Price_without_VAT: "Сумма без НДС",
  l_Balance_of_payments: "Баланс платежей",
  l_Payment_balance: "Остаток платежей",
  l_New_payment: "Новый платеж",
  l_Payment_type: "Тип платежа",
  l_Cash: "Наличный расчет",
  l_Refusal_comment: "Причины отказа от запроса",
  l_Cashless: "Безналичный",
  l_Comment_type: "Тип комментарии",
  l_Cargo_price: "Стоимость груза",
  l_Payment_date: "Дата платежа",
  l_Payment_amount: "Оплаченная сумма",
  l_Template_section: "Шаблоны",
  l_Freight: "Фрахт",
  l_Copying: "Копирование",
  l_Apply: "Применить",
  l_Add_line: "Добавить линию",
  l_Price_with_V: "Цена с НДС",
  l_Receiver: "Принял платеж",
  l_Costs: "Расходы",
  l_Profit: "Прибыль",
  l_Packing_type: "Тип упаковки",
  l_Quantity: "Количество",
  l_User: "Пользователь",
  l_Trip_number: "Нр. рейса",
  l_Weight: "Вес",
  l_Donnot_count_in_balance: "Не учитывать расход в финансах",
  l_Seperate_line_in_the_invoice: "Отдельная строка в счет",
  l_Income: "Доход",
  l_Volume: "Объем (м3)",
  l_Total_freight: "Общий фрахт",
  l_Template_group: "Группы документов",
  l_Add_template: "Новый документ",
  l_Document_templates_group: "Группа шаблонов документа",
  l_Change_status: "Изменить статус",
  l_XML_unloading: "XML выгрузка",
  l_Managers: "Менеджеры",
  l_Date_of_creation: "Дата создания",
  l_Client_type: "Тип клиента",
  l_TIN_taxpayer_ID_number_VAT: "УНН/ЕГРПОУ/VAT№",
  l_Activity_area: "Вид деятельности",
  l_OKPO: "ОКПО",
  l_TIN: "ИНН",
  l_BIN: "БИН",
  l_TRN: "РНН",
  l_Legal_address: "Юридический адрес ",
  l_Postal_address: "Почтовый адрес ",
  l_Payment_rules: "Правила оплаты",
  l_Credit_limit: "Кредитный лимит",
  l_Payment_delay: "Отсрочка платежа",
  l_Limit_exceeded: "Превышeниe лимитa",
  l_Deferred_payment_terms: "Усл. отсрочки платежей",
  l_Email_to_send_documents: "Эл. почта для отправки документов",
  l_Send_debt_remindings: "Отправлять напоминания о долгах",
  l_Swift: "Swift",
  l_PleaseEnterName: "Пожалуйста, введите имя",
  l_Contact_persons_posts: "Должность контакного лица",
  l_Contact_person: "Контактное лицо",
  l_Manager: "Менеджер",
  l_Days_from_the_latest_contract: "Дней от последнего контакта",
  l_Order_quantity: "Кол. заказов",
  l_Purchase_funnel: "Воронка продаж",
  l_Purchase_funnel_status: "Статус воронки продаж",
  l_Phone: "Телефон",
  l_Creation_date: "Дата создания",
  l_Type_of_the_received_document: "Вид полученного документа",
  l_Contact_personnel: "Контактные лица",
  l_Company_details: "Реквизиты компании",
  l_Active_requests: "Активные запросы",
  l_Archive_requests: "Архивные запросы",
  l_Archive: "Архивировать",
  l_Duly_represtnted: "В лице ..., На основании ...",
  l_Use_in_all_documents: "Использовать во всех документах",
  l_Phone_number: "Номер телефона",
  l_Skype: "Skype",
  l_ICQ: "ICQ",
  l_Comments: "Комментарии",
  l_PasswordNotLessThan6Letters: "Пароль должен содержать не менее 6 символов",
  l_Existed: "Существовал",
  l_EmailExisted: "Такой e-mail уже существует",
  l_Clients_order_number: "Номер заказа у клиента",
  l_Contacts: "Контакты",
  l_Default_forwarder: "Координатор",
  l_Additional_managers: "Freight coordinator",
  l_Price: "Цена",
  l_Price_with_VAT: "Начальная ставка с НДС",
  l_Deferred_payment_days: "Отсрочка платежа (дней)",
  l_Deferred_payment_conditions: "Условия отсрочки платежей",
  l_Full_text: "Полный текст",
  l_One_or_more_content_missing:
    "Один или несколько элементов контента отсутствуют",
  l_Statuses: "Статусы",
  l_Invoices: "Счета",
  l_Tasks: "Задачи",
  l_Number: "Нр.",
  l_Initial_freight: "Начальная ставка для клиента",
  l_Expenses: "Расходы",
  l_Forwarders: "Операторы",
  l_Documents_with_clients: "Документы с клиентом",
  l_Cargo_number: "Номер груза",
  l_Cargo_name: "Название груза",
  l_Cargo_parameters: "Параметры груза",
  l_Loading: "Погрузка",
  l_Access_to_req: "Доступ к запросам",
  l_Reloading_storage_place: "Место перезагрузки",
  l_Date_of_transhipment: "Дата перегрузки",
  l_Unloading: "Место разгрузки",
  l_Consignment_Price: "Стоимость груза",
  l_Loading_place: "Место загрузки",
  l_Time: "Время",
  l_Place_Company: "Место / Компания",
  l_Fullname: "Полное имя",
  l_Roles: "Роли",
  l_Work_time: "Время работы",
  l_Reset: "Сброс",
  l_Rate_date: "Дата курса",
  l_Contact_person_and_telephone: "Контактное лицо и телефон",
  l_Loading_place_customs: "Таможня загрузки",
  l_To: "До",
  l_New_company: "Новая компания",
  l_Delete: "Удалить",
  l_New_post: "",
  l_Unloading_place: "Место разгрузки",
  l_Unloading_place_customs: "Таможня разгрузки",
  l_Packing_type_quantity: "Тип упоковки/количество",
  l_Pallets: "Паллеты",
  l_Workers_post: "Должность сотрудников",
  l_Logs: "Логи",
  l_Session_log: "Журнал действий",
  l_LDM: "LDM (м)",
  l_Length: "Длина (м)",
  l_Different_acc_for_currency: "Разные счета для разных валют",
  l_Width: "Ширина (м)",
  l_Height: "Высота (м)",
  l_Document_is_sending: "Отправка документа",
  l_Sender: "Отправитель",
  l_Theme: "Тема",
  l_Send: "Отправить",
  l_Copy: "Копировать",
  l_Partial_cargo: "Неполный груз",
  l_Cargo_additional_information: "Дополнительная информация о грузе",
  l_Attributes: "Атрибуты",
  l_Insurance: "Страховка",
  l_More: "Подробнее",
  l_Less: "Скрыть",
  l_Successed: "Успешно выполнено",
  l_Terms_of_delivery: "Условия поставки (по Инкотермс 2010)",
  l_Transit_Time: "Транзитное время",
  l_Status: "Статус",
  l_Unloading_date: "Дата разгрузки",
  l_Carrier: "Перевозчик",
  l_Trip_or_cargo_number: "Нр. рейса / груза",
  l_Forwarder: "Оператор",
  l_Received_invoices: "Полученные счета",
  l_Cargos_and_Routes: "Грузы и Маршруты",
  l_Carrier_company: "Компания перевозчик",
  l_Carrier_contract_number_with_carrier: "Номер договора с перевозчиком",
  l_Insurance_policy_valid_until: "Срок действия страховки до",
  l_Number_in_carriers_system: "Номер в системе перевозчика",
  l_Trip: "Рейс",
  l_Terms_and_conditions_of_payment: "Срок и условия оплаты",
  l_Vehicle_number: "Номер тр. средства",
  l_Trailers_numbers: "Номера прицепа",
  l_Transport_type: "Тип транспорта",
  l_Loading_method: "Способ погрузки",
  l_Passport_number: "Номер паспорта",
  l_Driver: "Водитель",
  l_Container_number: "Номер контейнера",
  l_Sizes_L_W_H: "Габариты (Д*Ш*В)",
  l_Notification: "Уведомления",
  l_Amount: "Количество",
  l_Packing: "Упаковка",
  l_Order: "Заказ",
  l_Order_code_referral: "Реферальный код",
  l_Order_code_referral_short: "Реф. код",
  l_Invoice_received: "Полученные счета",
  l_Invoicess_issued: "Выписанные счета",
  l_Route: "Маршрут",
  l_Trip_expenses: "Расходы рейса",
  l_Car_trips_expenses: "Расходы авто рейсов",
  l_Rail_trips_expenses: "Расходы ЖД рейсов",
  l_Finance_operations: "Финансовые операции",
  l_Cargo_status: "Статус груза",
  l_Received_invoice: "Полученный счет",
  l_Expense: "Расход",
  l_Expenses_incl_VAT: "Расход с НДС",
  l_Dont_count_in_balance: "Не учитывать расход в финансах",
  l_Separate_line_in_the_invoice: "Отдельная строка в счёт",
  l_Expense_description: "Описание расходов",
  l_Document_name: "Название документа",
  l_Document_expiration_date: "Срок действия документа",
  l_Available_for_client: "Доступно для клиента",
  l_Type: "Тип",
  l_Template: "Шаблон документа",
  l_Attached_file: "Прикрепленый файл",
  l_Document_number: "Номер документа",
  l_Document_date: "Дата документа",
  l_Provide_access_to_the_client: "Предоставить доступ клиенту",
  l_File: "Файл",
  l_OverheadDocuments: "Накладные",
  l_Tags: "Теги",
  l_Rail_trips: "Железнодорожные рейсы",
  l_OtherDocuments: "Другие документы",
  l_Acts: "Акты",
  l_Photos: "Фотографии",
  l_Link: "Ссылка",
  l_To_comment: "Комментировать",
  l_Comment: "Комментарий",
  l_Cargo: "Груз",
  l_Place: "Место",
  l_ETA: "ETA",
  // l_Session_log:"Журнал действий",
  l_Data: "Данные",
  l_ID_session: "ID сессий",
  l_Brouser: "Браузер",
  l_Sent: "Отправлено",
  l_Author: "Автор",
  l_Trip_type: "Тип статуса",
  l_Neutral: "Нейтральный",
  l_Finish: "Конечный",
  l_Change_the_status_of_cargo_on_this_flight:
    "Изменить статус грузов в этом рейсе",
  l_Are_you_sure_you_want_to_update: "Вы уверены, что хотите обновить?",
  l_Finance_template: "Финансовый шаблон",
  l_Wagon_data: "Данные вагона",
  l_Train_Trip_number: "Номер поезда/рейса",
  l_Car_Container_number: "Номер вагона/контейнера",
  l_Cargo_data: "Данные груза",
  l_GNG_code: "ГНГ код",
  l_Classes_of_transport_rates: "ЕТСНГ",
  l_Rules_for_using_the_car: "Правила использования машины",
  l_Wagon_renter: "Арендатор вагона",
  l_Freight_with_VAT: "Фрахт с НДС",
  l_Login_: "Авторизоваться",
  l_Close: "Закрывать",
  l_Directions: "Направления",
  l_Full_name: "Полное имя",
  l_From: "Из",
  l_From_request: "Из запроса",
  l_Countries: "Страны",
  l_Drivers_name: "Имя водителя",
  l_Drivers_surname: "Фамилия водителя",
  l_Middle_name: "Отчество водителя",
  l_Passport: "Паспорт",
  l_Driving_licence_number: "Серия и номер вод. прав",
  l_Driving_licence_categories: "Категории вод. прав",
  l_Fuel_card: "Топливная карта",
  l_Organization_section: "Раздел организации",
  l_Is_active: "Работает",
  l_Permission_settings: "Настройки прав доступа",
  l_New_user: "Новый пользователь",
  l_Bank_account: "Номер счета",
  l_Contact_type: "Тип контакта",
  l_Vehicle: "Грузовой транспорт",
  l_Specifications: "Технические характеристики",
  l_Group_of_employees: "Группы сотрудников",
  l_updateStatus: "Обновить состояние",
  l_Group_name: "Название группы",
  l_Date_of_employment: "Дата приема на работу",
  l_Euro_emission_class: "Экологический класс",
  l_Trailer_number: "Номер прицепа",
  l_Brand: "Марка",
  l_Empty: "Пусто",
  l_No_data: "Нет данных",
  l_Contract_for_trips: "Договор для рейса",
  l_Without_stamp_and_sign: "Без печатей и подписей",
  l_Have_expiration_date: "Срок действия документа",
  l_Model: "Модель",
  l_Production_date: "Дата производства",
  l_Body_number: "Номер кузова",
  l_Registration_date: "Дата регистрации",
  l_Tech_passport_validity: "Срок действия Тех. Паспорта",
  l_License_number: "Номер лицензии",
  l_License_validity_date: "Срок действия лицензии",
  l_Drivers: "Тип транспорта",
  l_Transport_information: "Данные транспорта",
  l_Vehicle_empty_weight: "Собственная масса",
  l_Auto_pick_up: "Автозабор",
  l_Created: "Время создания",
  l_Exprired: "Срок действия документа",
  l_Element_rule_list: "	Список элементов правила",
  l_Position_of_contacts: "Позиции контактных людей",
  l_Adding: "Добавление",
  l_Sorting: "Сортировка",
  l_Name_of_the_kind_of_packing: "Наименование вида упаковки",
  l_Request_source: "Источник получения запроса",
  l_Classifier: "Справочники",
  l_Vehicle_full_weight: "Полная масса",
  l_Vehicle_axels: "Кол-во осей",
  l_Vat_rate: "Тариф НДС",
  l_Order_detail: "Детали заказа",
  l_Total_received_invoice: "Всего получено счетов:",
  l_Expences: "Расходы",
  l_Carrier_types: "Тип перевозчика",
  l_Received_payment: "Полученные платежи",
  l_Margin: "Маржа",
  l_New_request_purpose: "Новый цель запроса",
  l_Order_status_id: "Статус заказа",
  l_Type_of_transport: "Тип маршрута",
  l_New_carrier: "Новый перевозчик",
  l_Reply_deadline: "Ответ предоставить до даты",
  l_List_empty: "Список пуст",
  l_Total_issued_invoice: "Всего выписано счетов",
  l_Are_you_sure_to_confirm: "Вы уверены, что хотите подтвердить этот запрос?",
  l_Term: "Условие отсрочки платежей",
  l_Save: "Сохранить",
  l_Choose_client: "Выберите клиента",
  l_Add_service: "Новая услуга",
  l_Contact_partner: "Контактное лицо",
  l_New_contact_person: "Новое контактное лицо",
  l_New_payment_term: "Новое условие платежей",
  l_Deferred_payment_condition: "Условия отсрочки платежей",
  l_Max_weight: "Мах. Вес нагрузки",
  l_Max_euro_pallets: "Мах. кол-во евро-палет",
  l_External_trip: "Внешний рейс",
  l_Relevant_documents: "Необходимые документы",
  l_Add_cargo: "Добавить груз",
  l_Expence: "Расход",
  l_Payment_term: "Усл. отсрочки платежей",
  l_Click_or_drag_file_to_this_area_to_upload: "",
  l_Seller: "Продавец",
  //l_Total_received_invoice:"Всего получено счетов",
  l_Destination: "Отправление",
  l_Destination_time: "Время отправки",
  l_Departure: "Назначение",
  l_Departure_time: "Время доставки",
  l_Country_from: "Страна Из",
  l_Are_you_sure_to_cancel:
    "Вы уверены, что хотите изменить статус запроса на 'Неподтвержденный'?",
  l_Refusal_reason: "Причина отказа от запроса",
  l_Country_to: "Страна В",
  l_Receiving_date: "Дата получения",
  l_City_from: "Город Из",
  l_third_part_price: "Сторонний код",
  l_City_to: "Город В",
  l_Confirm: "Подтвердить",
  l_New_bank: "Новый банк",
  l_Confirm_and_create: "Подтвердить и создать",
  l_Contract_partner: "Контактное лицо",
  l_Direction: "Направление",
  l_Delivery_date: "Время доставки",
  l_Company_required: "Укажите компанию",
  l_Total_weight: "Общий вес",
  l_Total_volume: "Общий объем",
  l_Delivery_terms: "Условия поставки (по Инко термс 2010)",
  l_Transit_time: "Транзитное время",
  l_Number_in_carrier_system: "Номер в системе перевозчика",
  l_Price_proposals: "Ценовые предложения",
  l_Expence_without_VAT: "Сумма без НДС",
  l_Expence_with_VAT: "Расход с НДС",
  l_Bid_price: "Ставка",
  l_Bid_price_with_VAT: "Ставка с НДС",
  l_Request_date: "Дата запроса",
  l_Is_Partial_Cargo: "Неполный груз",
  l_Client_price: "Цена клиенту",
  l_Please_select_at_least_one_cargo: "Пожалуйста, выберите хотя бы один груз",
  l_Carrier_price: "Ставка перевозчика",
  l_Give_access_to_carrier: "Предоставить доступ перевозчику",
  l_Valid_from: "Действителен с",
  l_Notify_about_expiration: "Информоривать ",
  l_New_calculation: "Новый расчет",
  l_Valid_until: "Действителен до",
  l_Document_groups: "Группы документов",
  l_New_city: "Новый город",
  l_Template_name: "Название шаблона",
  l_Is_default: "По умолчанию",
  l_Service_type: "Вид перевозки",
  l_Cities: "Города",
  l_Position_of_contact_persons: "Позиции контактных людей",
  l_Packagings: "Упаковки",
  l_Statistical: "Статистический",
  l_Statistic: "Статистика",
  l_Unregistered: "Незарегистрированный",
  l_Role: "Управление",
  l_New_client: "Новый клиент",
  l_Product: "Продукт",
  l_The_reason_of_refusal: "Причина отказа от запроса",
  l_Request_sources: "Источник получения запроса",
  l_Request_purposes: "Цели запроса",
  l_Request_status: "Статус запросы",
  l_Permission: "Разрешение",
  l_Request_statuses: "Статусы запросы",
  l_Description: "Описание",
  l_Peromission_key: "Ключ разрешения",
  l_Parent_option: "Родительский параметр",
  l_Level: "Уровень",
  l_Postal_code: "Почтовый индекс",
  l_Additional_info: "Дополнительная информация",
  l_Logistician: "Логист",
  l_Extremely_urgent: "Чрезвычайно срочно",
  l_Product_type: "Тип продукта",
  l_Request_is_received: "Запрос принят?",
  l_Border_point: "Пограничный переход",
  l_Cost_per_cargo: "Разбить данный расход по связанным заказам",
  l_By_weight: "По весу",
  l_By_volume: "По объему",
  l_By_weight_and_volume: "По весу и объему",
  l_Batch_setting_cargo_status: "Пакетная установка статуса груза",
  l_Selected: "Выбрано",
  l_not_selected: "Не выбрано",
  l_Distribute_percent: "Процент распределения",
  l_Distribute_price: "Цена распределения",
  l_Total: "Всего",
  l_Clear: "Очистить",
  l_Request_purpose: "Цель запросы",
  l_Request_number: "Номер запроса",
  l_By: "По",
  l_Add_date: "Добавить дату",
  l_Update_date: "Дата обновления",
  l_Descending: "По убыванию",
  l_Ascending: "По возрастанию",
  l_Invoice: "Счет",
  l_Invoices_issued: "Выписанные счета",
  l_invoiceNumber: "Номер счета",
  l_Change_order_status: "Изменить статус заказа",
  l_senderInvoice: "Компания",
  l_issuedDate: "Счет выписан",
  l_receivingDate: "Дата получения",
  l_payUntilDate: "Оплатить до",
  l_Trip_status: "Статус рейса",
  l_Without_VAT: "без НДС",
  l_With_VAT: "с НДС",
  l_Invoice_line: "Строка счета",
  l_Unit: "Ед.",
  l_Received_from: "Получен от",
  l_Company_which_received_the_invoice: "Компания которая получила счет",
  l_Breaking_rule: "Правило разбивки",
  l_Contractor: "Исполнитель",
  l_Payer: "Плательщик",
  l_Language: "Язык",
  l_Made: "Составил",
  l_Notes: "Примечания",
  l_Devider: "Делитель",
  l_Element: "Элемент",
  l_Percent: "Процент",
  l_INN_EGRPOU_VAT_BIN_UNN: "ИНН, ЕГРПОУ, VAT, БИН, УНН",
  l_Start: "Старт",
  l_End: "Конец",
  l_Contract_date: "Дата контракта",
  l_Contract_number: "Номер договора с клиентом",
  l_Has_contract: "Есть договор",
  l_Contragents: "Контрагенты",
  l_Rail_trip: "Железнодорожные рейсы",
  l_Issued_invoice_in_order: "Выставленный счёт в заказе",
  l_Status_history: "История статусов",
  l_New_request: "Новый запрос",
  l_Notification_language: "Язык уведомлений",
  l_Classifier_section: "Раздел справочников",
  l_Images_for_docs: "Изображения для документов",
  l_Director: "ФИО руководителя",
  l_Representive_name: "В лице кого",
  l_Worker_post: "Должность",
  l_Company_prefix: "Префикс компании",
  l_Stamp: "Stamp",
  l_Logo: "Logo",
  l_Sign: "Sign",
  l_New_cargo: "Новый груз",
  l_New_country: "Новая страна",
  l_Default_country: "Страна по умолчанию",
  l_European_country: "Европейская страна",
  l_Postponement_days: "Дни отсрочки",
  l_Is_Use_nonstandard_invoice_template:
    "Использовать нестандартный шаблон счета",
  l_Is_without_StampAnd_Signature: "Без печатей и подписей",
  l_Visible_for_client: "Виден клиенту",
  l_Received_date: "Счет выписан",
  l_Trailers_number: "Номер прицепа",
  l_Client_type_definition:
    "Типы клиентов - классификация Клиентов по важности/срочности.Заполняется в карточке Клиента и взаимодействует с Запросами. При заполнении справочника можно установить приоритет сегмента. Эта цифра определяет важность и позицию Запроса от клиента с данным Типом. Работает так: добавляем в справочник Тип клиента VIP, приоритет сегмента - 1. Далее в карточке нужного Клиента выбираем данный тип и все запросы от данного Клиента будут расположены в самом верху общей таблицы Запросов независимо от того, в каком порядке они поступили. Также в блоке Клиенты можно использовать фильтр, чтобы сделать выборку по Клиентам определенного Типа.",
  l_Trip_number_must_be_unique: "Рейс с таким номером уже существует",
  l_Company_is_required: "Выберите компанию",
  l_File_is_required: "Загрузите файлы",
  l_Comment_is_required: "Заполните комментарий",
  l_Contract_is_required: "Выберите нр. рейса",
  l_Company_name_is_required: "Введите название компании",
  l_Business_number_is_required: "Введите номер",
  l_Required_field: "Обязательное поле",
  l_Select_required: "Выберите значение",
  l_Type_to_search_orders: "Введите заказ для поиска",
};
